import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
  CustomText,
  CustomTextArea,
  ConfirmationDialog,
  Image,
  PrimaryCta,
  Video,
  ViewCards,
  CustomTextInput,
} from "../../components";
import { UploadContentIcon } from "../../components/assets/icons";
import { format, setHours, setMinutes } from "date-fns";
import "react-best-tabs/dist/index.css";
import { ModalComponent } from "../../components";
import Icon from "../../components/core_component/icon";
import Core from "../../common/clientSdk";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UploadImageS3 from "../../common/s3";
import { useSelector } from "react-redux";
import { type } from "@testing-library/user-event/dist/type";
import Utils from "../../common/utils";
import { Loader } from "../loader";
import { saveAs } from "file-saver";
import { useSnackbar } from "react-simple-snackbar";
import Modal from "react-modal";
import validator from "validator";
import ReactGA from "react-ga";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import PayoutFlyOut from "./payoutFlyOut";
import { Rating } from "react-simple-star-rating";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "var(--general-secondary-color)",
    textAlign: "center",
    zIndex: "5",
    height: "40%",
    display: "flex",
    flexDirection: "column",
    // justifyContent: "space-around",
    minWidth: "658px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.86)",
    zIndex: 10,
  },
};

const CancelReminder = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "var(--general-secondary-color)",
    textAlign: "center",
    zIndex: "5",
    height: "40%",
    display: "flex",
    flexDirection: "column",
    minWidth: "658px",
    height: "130px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.95)",
    zIndex: 10,
  },
};

const contractId = ["48w45x", "2vla9s", "tlezgd", "1u3tdg"];

function ContentAdminStatusScreen(props) {
  const [activeTab, setActiveTab] = useState("detail-page");
  const [assignmentDeepData, setAssignmentDeepData] = useState({});
  const [influencerDetail, setInfluencerDetail] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [isRatingButtonLoading, setRatingButtonLoading] = useState(false);
  const [loadingButtons, setLoadingButtons] = useState({});
  const [rejectedLoader, setRejectedLoader] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [rejectedText, setRejectedText] = useState("");
  const [openSnackbar] = useSnackbar();
  const [showImage, setShowImage] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [showmodal, setShowModal] = useState(false);
  const [selectedContentId, setSelectedContentId] = useState(null);
  const [showVideo, setShowVideo] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [uploadType, setUploadType] = useState("file"); // 'file' or 'link'
  const [rating, setRating] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [cancelContractLoading, setCancelContractLoading] = useState(false);
  const [approveDialog, setApproveDialog] = useState(false);
  const [payoutOpen, setPayoutOpen] = useState(false);
  const [pgOrderId, setPgOrderId] = useState("");
  const mediaIdRef = useRef(null);

  const [openModal2, setOpenModal2] = useState(false);
  const [error, set_error] = useState({
    content_rejected: "",
  });
  const assignment_id = useParams().id;
  console.log("id in screen", assignment_id);

  const handleVideoClick = () => {
    console.log("sandeep");
    setShowVideo(!showVideo);
  };

  const handleContextMenu = (e) => {
    e.preventDefault(); // Prevent default right-click behavior
  };

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const contentId = params.get("content_id");

  useEffect(() => {
    assignmentAdminDetails(updateProgress);
  }, []);

  useEffect(() => {
    // Check if any content is in review
    if (assignmentDeepData.contents_deep_data) {
      const isInReview = Object.values(
        assignmentDeepData.contents_deep_data
      ).every((item) => item.content_data.status === "IN_REVIEW");

      if (isInReview) {
        setActiveStep(1); // Advance the stepper
      }
      const isComplete = Object.values(
        assignmentDeepData.contents_deep_data
      ).every(
        (item) =>
          item.content_data.status === "COMPLETED" ||
          item.content_data.status === "CONTENT_PENDING"
      );

      if (isComplete) {
        setActiveStep(2); // Advance the stepper
      }
      const isUrl = Object.values(assignmentDeepData.contents_deep_data).every(
        (item) => item.content_data.url
      );
      if (isUrl) {
        setActiveStep(3);
      }
    }
  }, [assignmentDeepData]);

  function updateProgressCancelContract(status) {
    setCancelContractLoading(status);
  }
  function postCancelContract() {
    const params = {
      assignment_id: assignment_id,
    };
    Core.postCancelContract(
      postCancelContractSuccess,
      postCancelContractFailed,
      updateProgressCancelContract,
      params
    );
  }

  function postCancelContractSuccess() {
    assignmentAdminDetails(updateProgress);
    toggleCloseModal();
  }

  function postCancelContractFailed(errorList) {
    toast.error(errorList.map((item) => item.m).join(", "));
  }

  const toggleModal = () => {
    setOpenModal2(!openModal2);
  };
  const toggleCloseModal = () => {
    setOpenModal2(false);
  };

  function updateProgress(status) {
    // setLoading(status)
  }

  const toggleFlyoutDropdown = () => {
    setPayoutOpen(!payoutOpen);
  };

  const handleClick = () => {
    setShowImage(!showImage);
  };

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function showModal() {
    setShowModal(true);
  }

  function HideModel() {
    setShowModal(false);
  }

  // rating
  const handleRating = (rate) => {
    setRating(rate);
  };

  function validateContent(value) {
    if (validator.isEmpty(value, {})) {
      set_error({ ...error, content_rejected: "Please Enter Feedback" });
      openSnackbar("Please Enter Content Feedback");
    } else {
      set_error({ ...error, content_rejected: "" });
      return true;
    }
  }

  var redux_selector = useSelector((state) => {
    return {
      BrandUser: state.BrandUserDataReducer,
      Auth: state.BrandUserAuthReducer,
    };
  });

  const { BrandUser = {} } = redux_selector;
  const { brand_deep_data = {} } = BrandUser;
  const { brand_data = {} } = brand_deep_data;

  // assignment cancel API
  function postAssignmentWithdraw() {
    const params = {
      assignment_id: assignment_id,
    };
    Core.postAssignmentWithdraw(
      postAssignmentWithdrawSuccess,
      postAssignmentWithdrawFailed,
      (status) => setLoading(status),
      params
    );
  }

  function postAssignmentWithdrawSuccess(response_data) {
    assignmentAdminDetails(updateProgress);
    HideModel();
    toast.success("Contract cancelled and refund initiated");
  }
  function postAssignmentWithdrawFailed(errorList) {
    toast.error(errorList.map((item) => item.m).join(", "));
  }

  // influncer rating
  function postRatingInfluencer(influencer_id) {
    if (rating == 0) {
      return;
    }
    const params = {
      review_points: rating,
      assignment_id: assignment_id,
      review: "active",
      influencer_id: assignmentDeepData.influencer_data.influencer_id,
    };
    Core.postRatingInfluencer(
      getInfluncerRatingSuccess,
      getInfluncerRatingFailed,
      (status) => setRatingButtonLoading(status),
      params
    );
  }

  function getInfluncerRatingSuccess(response_data) {
    toast.success("Thanks for rating the Influencer");
    assignmentAdminDetails(updateProgress);
  }

  function getInfluncerRatingFailed(errorList) {
    // openSnackbar(errorList.map((item) => item.m).join(", "));
  }

  function assignmentAdminDetails() {
    const params = {
      assignment_id: assignment_id,
    };
    Core.assignmentAdminDetails(
      assignmentAdminDetailsSuccess,
      assignmentAdminDetailsFailed,
      updateProgress,
      params
    );
  }

  function assignmentAdminDetailsSuccess(response_data) {
    setAssignmentDeepData(response_data.assignment_deep_data);
  }

  function assignmentAdminDetailsFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  }

  function ContentStatusApprove(approvedContentId) {
    setLoadingButtons(prev => ({ ...prev, [approvedContentId]: true }));
    const params = {
      assignment_id: assignment_id,
      content_id: approvedContentId,
      is_approved: "true",
    };
    Core.postUserAssignmentReviewContent(
      (response) => ContentStatusApproveSuccess(response, approvedContentId),
      (error) => ContentStatusApproveFailed(error, approvedContentId),
      (status) => {
        if (!status) {
          setLoadingButtons(prev => ({ ...prev, [approvedContentId]: false }));
        }
      },
      params
    );
  }

  function ContentStatusApproveSuccess(response_data, contentId) {
    setLoadingButtons(prev => {
      const newState = { ...prev };
      delete newState[contentId];
      return newState;
    });
    assignmentAdminDetails(updateProgress);
    props.assignmentAdminDetails();
    openSnackbar("Content approved");
  }

  function ContentStatusApproveFailed(errorList, contentId) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
    setLoadingButtons(prev => ({ ...prev, [contentId]: false }));
  }

  function contractCheck(content_id) {
    if (contractId.includes(assignment_id)) {
      toggleFlyoutDropdown();
    } else {
      ContentStatusApprove(content_id);
    }
  }

  function ContentStatusRejected(content_id) {
    const params = {
      assignment_id: assignment_id,
      content_id: content_id,
      comment: rejectedText,
      is_approved: "false",
    };
    if (validateContent(rejectedText))
      Core.postUserAssignmentReviewContent(
        ContentStatusRejectedSuccess,
        ContentStatusRejectedFailed,
        (status) => setRejectedLoader(status),
        params
      );
  }

  function ContentStatusRejectedSuccess(response_data) {
    assignmentAdminDetails();
    openSnackbar("Content rejected");
    setRejectedText("");
    setSelectedContentId(null);
    props.assignmentAdminDetails();
  }

  function ContentStatusRejectedFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  }

  const totalAssignment = Object.keys(assignmentDeepData).length;

  let completedAssignment = 0;
  let inReview = 0;
  let contentPending = 0;
  let rework = 0;
  let newAssignment = 0;

  assignmentDeepData.contents_deep_data &&
    Object.keys(assignmentDeepData.contents_deep_data).map((item) => {
      const { status } =
        assignmentDeepData.contents_deep_data[item].content_data;
      if (status == "COMPLETED") {
        completedAssignment++;
      }
      if (status == "IN_REVIEW") {
        inReview++;
      }
      if (status == "CONTENT_PENDING") {
        contentPending++;
      }
      if (status == "REWORK") {
        rework++;
      }
      if (status == "NEW") {
        newAssignment++;
      }
      return {};
    });

  function googleAnalytics() {
    ReactGA.event({
      category: "User",
      action: "REELAX_ADS_WEB_LOGIN",
    });
  }

  const { influencer_data = {}, campaign_data = {} } = assignmentDeepData;
  const { type = {} } = campaign_data;

  function ContentFallBack(props) {
    return (
      <ViewCards>
        <div className="content-fall-back-container">
          <div className="m-b-16">
            <Icon iconName="InstagramIconNonColoredIcon" />
          </div>
          <CustomText
            p
            textColor={"text_color_primary"}
            fontSize={"font_size_small"}
            fontWeight={"Poppins_lightItalic"}
            text={props.textPrimary}
          />
          <CustomText
            p
            textColor={"text_color_primary"}
            fontSize={"font_size_small"}
            fontWeight={"Poppins_lightItalic"}
            text={props.textSecondary}
          />
        </div>
      </ViewCards>
    );
  }

  const ImageView = ({ imageUrl }) => {
    const [zoomed, setZoomed] = useState(false);

    const toggleZoom = () => {
      setZoomed(!zoomed);
    };

    const closeZoom = () => {
      setZoomed(false);
    };

    return (
      <>
        <div className={`image-zoom-container ${zoomed ? "zoomed" : ""}`}>
          <div className="content-close-icon" onClick={closeZoom}>
            {zoomed && <Icon iconName="CloseRoundButtonIcon" />}
          </div>
          <img
            src={imageUrl}
            alt="Image"
            className={`image-content-status ${zoomed ? "zoomed" : ""}`}
            onClick={toggleZoom}
          />
        </div>
      </>
    );
  };

  const VideoPlayer = ({ videoUrl }) => {
    const [playing, setPlaying] = useState(false);

    const togglePlaying = () => {
      setPlaying(!playing);
    };

    const closeVideo = () => {
      setPlaying(false);
    };

    return (
      <div className={`video-player-container ${playing ? "playing" : ""}`}>
        <div className="content-close-icon" onClick={closeVideo}>
          {playing && (
            <Icon iconName="CloseRoundButtonIcon" onClick={closeVideo} />
          )}
        </div>
        <video
          controlsList="nodownload"
          src={videoUrl}
          className={`video-content-status ${playing ? "playing" : ""}`}
          onClick={togglePlaying}
          controls
        />
      </div>
    );
  };

  const handleCancel = () => {
    setApproveDialog(false);
  };

  function ContentInReview() {
    if (inReview > 0 || completedAssignment > 0 || contentPending > 0) {
      return (
        <>
          <div className="content-pending-container">
            {assignmentDeepData.contents_deep_data &&
              Object.keys(assignmentDeepData.contents_deep_data).map(
                (item, index) => {
                  const { content_id, status, media_id } =
                    assignmentDeepData.contents_deep_data[item].content_data;
                  const { name, platform_id } =
                    assignmentDeepData.contents_deep_data[item].platform_data;

                  if (status == "IN_REVIEW") {
                    if (media_id.split(".").pop() == "mp4") {
                      return (
                        <>
                          {index === 0 && (
                            <div
                              className="content-pending-card"
                              style={{
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div className="m-r-8">
                                  <Icon
                                    iconName={Utils.socialMediaIcons(
                                      platform_id
                                    )}
                                    height={24}
                                    width={24}
                                  />
                                </div>

                                <CustomText
                                  p
                                  className="content-pending-card-text"
                                  text={name}
                                  textColor={"text_color_gray_500"}
                                />
                              </div>
                              <div
                                className="Caption1"
                                style={{ color: "var(--gray-gray-400)" }}
                              >
                                {/*  {currentTime()} */}
                              </div>
                            </div>
                          )}

                          <div className="content-pending-content-imagecard">
                            <div className="content-status-media">
                              <div onClick={handleVideoClick}>
                                <video
                                  controlsList="nodownload"
                                  preload="metadata"
                                  width={96}
                                  height={96}
                                  type={"video/mp4"}
                                  onContextMenu={handleContextMenu}
                                >
                                  <source
                                    src={Utils.constructContentMediaUrl(
                                      assignment_id,
                                      media_id
                                    )}
                                    type="video/mp4"
                                  ></source>
                                </video>
                              </div>

                              {showVideo && (
                                <div className="fullscreen-image">
                                  <div
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <div
                                      onClick={handleVideoClick}
                                      className="fullscreen-image-close-btn"
                                    >
                                      <Icon iconName="CloseRoundButtonIcon" />
                                    </div>
                                    <Video
                                      source={Utils.constructContentMediaUrl(
                                        assignment_id,
                                        media_id
                                      )}
                                      width={600}
                                      height={337}
                                      type={"video/mp4"}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="content-status-bottom-container">
                              <div>
                                <PrimaryCta
                                  invertSmall
                                  onClick={() => {
                                    openModal();
                                    setSelectedContentId(content_id);
                                  }}
                                  fontSize={"font_size_large"}
                                  text={"Reject"}
                                  isLoading={rejectedLoader}
                                />
                              </div>
                              <div>
                                <PrimaryCta
                                  fifth
                                  onClick={() => {
                                    contractCheck(content_id);
                                  }}
                                  fontSize={"font_size_large"}
                                  text={"Approve"}
                                  isLoading={loadingButtons[content_id] || false}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    } else {
                      return (
                        <>
                          {index === 0 && (
                            <div
                              className="content-pending-card"
                              style={{
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div className="m-r-8">
                                  <Icon
                                    iconName={Utils.socialMediaIcons(
                                      platform_id
                                    )}
                                    height={24}
                                    width={24}
                                  />
                                </div>

                                <CustomText
                                  p
                                  className="content-pending-card-text"
                                  text={name}
                                  textColor={"text_color_gray_500"}
                                />
                              </div>
                              {/* <div className="Caption1">{currentTime()}</div> */}
                            </div>
                          )}
                          <div className="content-pending-content-imagecard">
                            <div
                              style={{ position: "relative" }}
                              onClick={handleClick}
                              className="content-status-media"
                            >
                              {/* <ImageView
                            imageUrl={Utils.constructContentMediaUrl(
                              assignment_id,
                              media_id
                            )}
                          /> */}
                              <Image
                                source={Utils.constructContentMediaUrl(
                                  assignment_id,
                                  media_id
                                )}
                                width={96}
                                height={96}
                              />
                              {showImage && (
                                <div className="fullscreen-image">
                                  <div style={{ position: "relative" }}>
                                    <div className="fullscreen-image-close-btn">
                                      <Icon iconName="CloseRoundButtonIcon" />
                                    </div>
                                    <Image
                                      source={Utils.constructContentMediaUrl(
                                        assignment_id,
                                        media_id
                                      )}
                                      width={600}
                                      height={337}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="content-status-bottom-container">
                              <div>
                                <PrimaryCta
                                  invert
                                  onClick={() => {
                                    openModal();
                                    setSelectedContentId(content_id);
                                  }}
                                  fontSize={"font_size_large"}
                                  text={"Reject"}
                                  isLoading={rejectedLoader}
                                />
                              </div>
                              <div>
                                <PrimaryCta
                                  fifth
                                  onClick={() => {
                                    contractCheck(content_id);
                                  }}
                                  fontSize={"font_size_large"}
                                  text={"Approve"}
                                  isLoading={loadingButtons[content_id] || false}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    }
                  }
                  if (status == "COMPLETED" || status == "CONTENT_PENDING") {
                    return (
                      <>
                        {index === 0 && (
                          <div
                            className="content-pending-card"
                            style={{
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div className="m-r-8">
                                <Icon
                                  iconName={Utils.socialMediaIcons(platform_id)}
                                  height={24}
                                  width={24}
                                />
                              </div>

                              <CustomText
                                p
                                className="content-pending-card-text"
                                text={name}
                                textColor={"text_color_gray_500"}
                              />
                            </div>
                            {/* <div className="Caption1">{currentTime()}</div> */}
                          </div>
                        )}
                        {index === 0 && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "column",
                              padding: "33px 35px",
                              gap: 8,
                            }}
                          >
                            {" "}
                            <Icon iconName="InReviewContent" />{" "}
                            <CustomText
                              p
                              className="subtitle1"
                              text={"I have approve the content"}
                              textColor={"text_color_gray_500"}
                            />
                          </div>
                        )}
                        {/* <div>
                          <PrimaryCta
                            fifth
                            onClick={() => {
                              setApproveDialog(true);
                              setSelectedContentId(content_id);
                            }}
                            fontSize={"font_size_large"}
                            text={"payment"}
                            isLoading={isLoadingButton}
                          />
                        </div> */}
                      </>
                    );
                  }
                }
              )}
          </div>
        </>
      );
    }
  }

  function ContentCompleted() {
    const [contentUrls, setContentUrls] = useState({}); // Store URLs for each content separately
    const [submitLoading, setSubmitLoading] = useState({}); // Track loading state for each content submission
    
    const handleContentUrlChange = (content_id, value) => {
      setContentUrls(prev => ({
        ...prev,
        [content_id]: value
      }));
    };
    
    const handleContentUrlSubmit = (content_id) => {
      const url = contentUrls[content_id] || '';
      if (!url) {
        openSnackbar("Please enter a URL");
        return;
      }
      
      // Set loading state for this specific content
      setSubmitLoading(prev => ({
        ...prev,
        [content_id]: true
      }));
      
      let params={
        assignment_id: assignmentDeepData?.assignment_data?.assignment_id,
        influencer_id: assignmentDeepData?.assignment_data?.influencer_id,
        content_url: url,
        content_id: content_id
      }
      
      Core.submitContentUrl(
        () => {
          // Success callback
          setContentUrls(prev => ({
            ...prev,
            [content_id]: '' // Clear the input after successful submission
          }));
          setSubmitLoading(prev => ({
            ...prev,
            [content_id]: false
          }));
          assignmentAdminDetails(updateProgress);
          openSnackbar("Link Submitted Successfully");
        },
        (errorList) => {
          // Error callback
          setSubmitLoading(prev => ({
            ...prev,
            [content_id]: false
          }));
          openSnackbar(errorList.map((item) => item.m).join(", "));
        },
        ()=>{},
        params
      )
    };

    const handleDownload = (media_id, isVideo) => {
      const mediaUrl = Utils.constructContentMediaUrl(assignment_id, media_id);

      // Create a temporary anchor element to trigger the download
      const a = document.createElement("a");
      a.href = mediaUrl;
      a.download = `downloaded_${isVideo ? "video" : "image"}.${media_id
        .split(".")
        .pop()}`;
      a.style.display = "none";

      document.body.appendChild(a);
      a.click();

      // Clean up the anchor element
      document.body.removeChild(a);
    };

    if (completedAssignment > 0 || contentPending > 0) {
      return (
        <div className="content-pending-container">
          {/* {completedAssignment === 0 ? (
            <>
              <ContentFallBack
                textPrimary="No content available"
                textSecondary="Ready contents will be shown here"
              />
            </>
          ) : ( */}
          <>
            {assignmentDeepData.contents_deep_data &&
              Object.keys(assignmentDeepData.contents_deep_data).map(
                (item, index) => {
                  const { content_id, content_type_id, status, media_id, url } =
                    assignmentDeepData.contents_deep_data[item].content_data;
                  const { platform_id } =
                    assignmentDeepData.contents_deep_data[item].platform_data;

                  const openUrl = () => {
                    window.open(url);
                  };

                  if (campaign_data.type === "social_media") {
                    if (status == "COMPLETED") {
                      return (
                        <>
                          {index === 0 && (
                            <div className="content-pending-card">
                              <div className="m-r-8">
                                <Icon
                                  iconName={Utils.socialMediaIcons(platform_id)}
                                  height={24}
                                  width={24}
                                />
                              </div>

                              <CustomText
                                p
                                className="content-pending-card-text"
                                text={"Content Social Link"}
                                textColor={"text_color_gray_500"}
                              />
                            </div>
                          )}
                          <div className="m-b-12">
                            <div
                              className="content-pending-content-card"
                              onClick={() => openUrl()}
                            >
                              <CustomText
                                p
                                className="Body-1 content-url cursor-pointer"
                                text={url && url}
                                textColor={"text_color_blue_500"}
                              />

                              <div>
                                <Icon
                                  iconName={"contentStatusCheckIcon"}
                                  height={24}
                                  width={24}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    }
                    if (status == "CONTENT_PENDING") {
                      return (
                        <>
                          {index === 0 && (
                            <div className="content-pending-card">
                              <div className="m-r-8">
                                <Icon
                                  iconName={Utils.socialMediaIcons(platform_id)}
                                  height={24}
                                  width={24}
                                />
                              </div>

                              <CustomText
                                p
                                className="content-pending-card-text"
                                text={"Content Social Link"}
                              />
                            </div>
                          )}
                          <div className="m-b-12">
                            {/* <div className="content-pending-content-card">
                              <CustomText
                                p
                                className="Body-1 content-url"
                                text={Utils.getContentTypeNameById(
                                  content_type_id
                                )}
                                textColor={"text_color_gray_400"}
                              />

                              <div>
                                <Icon
                                  iconName={"pendingTimeIcon"}
                                  height={24}
                                  width={24}
                                />
                              </div>
                            </div> */}
                            <div
                              className="content-pending-content-card"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "left",
                                justifyContent:"left"
                              }}
                            >
                              <div>
                                <CustomText
                                  p
                                  className="Body-1 content-url"
                                  text={`Upload ${Utils.getContentTypeNameById(
                                    content_type_id
                                  )} Link`}
                                  textColor={"text_color_gray_400"}
                                />
                              </div>
                              <div>
                                <CustomTextInput
                                  value={contentUrls[content_id] || ''}
                                  onChange={(e) => handleContentUrlChange(content_id, e.target.value)}
                                  placeHolder={"Add your link"}
                                  type="text"
                                />
                              </div>
                              <div>
                                <PrimaryCta
                                  fifth
                                  text={`Submit Link`}
                                  onClick={() => handleContentUrlSubmit(content_id)}
                                  isLoading={submitLoading[content_id] || false}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    }
                  }
                  if (
                    campaign_data.type === "content" &&
                    status == "COMPLETED"
                  ) {
                    if (media_id.split(".").pop() === "mp4") {
                      return (
                        <ViewCards style={{ marginBottom: "10px" }}>
                          <div className="content-status-media">
                            <div onClick={handleVideoClick}>
                              <video
                                preload="metadata"
                                width={"100%"}
                                height={"100%"}
                                type={"video/mp4"}
                              >
                                <source
                                  src={Utils.constructContentMediaUrl(
                                    assignment_id,
                                    media_id
                                  )}
                                  type="video/mp4"
                                ></source>
                              </video>
                            </div>
                            {showVideo && (
                              <div className="fullscreen-image">
                                <div
                                  style={{
                                    position: "relative",
                                    backgroundColor: "var( --gray-gray-500)",
                                  }}
                                >
                                  <div
                                    onClick={handleVideoClick}
                                    className="fullscreen-image-close-btn"
                                  >
                                    <Icon iconName="CloseRoundButtonIcon" />
                                  </div>
                                  <Video
                                    source={Utils.constructContentMediaUrl(
                                      assignment_id,
                                      media_id
                                    )}
                                    width={600}
                                    height={337}
                                    type={"video/mp4"}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="content-status-bottom-container">
                            {type === "content" && (
                              <div>
                                <PrimaryCta
                                  fifth
                                  onClick={() => handleDownload(media_id, true)}
                                  fontSize={"font_size_large"}
                                  text={"Download"}
                                  isLoading={isLoading}
                                />
                              </div>
                            )}
                          </div>
                        </ViewCards>
                      );
                    } else {
                      return (
                        <ViewCards style={{ marginBottom: "10px" }}>
                          <div
                            style={{ position: "relative" }}
                            onClick={handleClick}
                            className="content-status-media"
                          >
                            <Image
                              source={Utils.constructContentMediaUrl(
                                assignment_id,
                                media_id
                              )}
                              width={"100%"}
                              height={"100%"}
                            />
                            {showImage && (
                              <div className="fullscreen-image">
                                <div style={{ position: "relative" }}>
                                  <div className="fullscreen-image-close-btn">
                                    <Icon iconName="CloseRoundButtonIcon" />
                                  </div>
                                  <Image
                                    source={Utils.constructContentMediaUrl(
                                      assignment_id,
                                      media_id
                                    )}
                                    width={600}
                                    height={337}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="content-status-bottom-container">
                            {type === "content" && (
                              <div>
                                {/* Replace empty onClick with the download function */}
                                <PrimaryCta
                                  fifth
                                  onClick={() => handleDownload(media_id, true)}
                                  fontSize={"font_size_large"}
                                  text={"Download"}
                                  isLoading={isLoading}
                                />
                              </div>
                            )}
                          </div>
                        </ViewCards>
                      );
                    }
                  }
                }
              )}
          </>
          {/* )} */}
        </div>
      );
    }
  }

  function ContentPending() {
    const [isUploading, setIsUploading] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [mediaId, setMediaId] = useState(null);
    const [filePreview, setFilePreview] = useState(null);
    const [selectedContentId, setSelectedContentId] = useState(null);
    const [contentUrls, setContentUrls] = useState({}); // Store URLs for each content separately
    const [uploadType, setUploadType] = useState("file"); // 'file' or 'link'
    const [submittedContents, setSubmittedContents] = useState({}); // Track submitted content status

    // Reset content URL when switching between upload types
    const setUploadTypeWithReset = (type) => {
      setUploadType(type);
      if (type === "file") {
        // We don't reset all URLs here since they're managed per content
      } else {
        if (filePreview) {
          URL.revokeObjectURL(filePreview);
          setFilePreview(null);
          setUploadedFile(null);
        }
      }
    };
    
    const handleContentUrlChange = (content_id, value) => {
      setContentUrls(prev => ({
        ...prev,
        [content_id]: value
      }));
    };
    
    const getContentUrl = (content_id) => {
      return contentUrls[content_id] || '';
    };

    const handleUploadClick = (contentId) => {
      // Allow changing file for the currently selected content
      const isChangingCurrentFile = selectedContentId === contentId;
      
      // Only check for pending content if not changing the current file
      if (!isChangingCurrentFile) {
        const hasPendingContent = Object.values(submittedContents).some(
          (status, id) => status === 'pending'
        );

        if (hasPendingContent) {
          toast.error("Please submit or cancel the current content before adding a new one");
          return;
        }
      }

      // Create a new input element each time to ensure it works on subsequent clicks
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*,video/*";
      input.style.display = 'none'; // Hide the input element

      // Handle file selection
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (file) {
          // Reset previous uploads
          if (filePreview) {
            URL.revokeObjectURL(filePreview);
            setFilePreview(null);
          }

          // Show preview immediately
          const previewUrl = URL.createObjectURL(file);
          setFilePreview(previewUrl);
          setSelectedContentId(contentId);
          setUploadType("file");
          
          // Mark this content as pending submission
          setSubmittedContents(prev => ({
            ...prev,
            [contentId]: 'pending'
          }));

          // Start the upload process
          generateUploadUrl(file, contentId);
        }
        // Clean up the input element after use
        document.body.removeChild(input);
      };

      // Add the input to the DOM (needed for iOS)
      document.body.appendChild(input);

      // Trigger the file picker
      input.click();
      
      // Handle iOS bug where onchange doesn't fire if the same file is selected again
      if (navigator.userAgent.match(/(iPod|iPhone|iPad)/i)) {
        input.value = '';
      }
    };

    const generateUploadUrl = (file, contentId) => {
      setIsUploading(true);

      const params = {
        id: assignmentDeepData.assignment_data.assignment_id,
        file_type: file.type,
        action: "contract_content",
      };

      Core.uploadToS3(
        (success, data) => uploadToS3(contentId, file, data),
        handleUploadError,
        () => {},
        params
      );
    };

    function uploadToS3(contentId, file, response) {
      console.log("response of s3", response);

      const previewUrl = URL.createObjectURL(file);

      const { upload_data } = response;

      if (!upload_data?.media_id) {
        handleUploadError("Media ID missing from upload response");
        return;
      }

      // ✅ STORE MEDIA ID SAFELY
      mediaIdRef.current = upload_data.media_id;
      setMediaId(upload_data.media_id);

      upload_data.fields["Content-Type"] = file.type;

      UploadImageS3(file, upload_data, (error) => {
        if (error) {
          handleUploadError("Failed to upload file to S3");
          return;
        }

        setUploadedFile({
          file,
          mediaId: upload_data.media_id,
          type: file.type,
          name: file.name,
        });

        setFilePreview(previewUrl);
        setSelectedContentId(contentId);
        setIsUploading(false);

        toast.success("File uploaded successfully! Please review and submit.");
      });
    }

    const handleSubmitContent = () => {
      const finalMediaId = mediaIdRef.current;

      console.log("Submitting:", finalMediaId, selectedContentId);

      if (!finalMediaId || !selectedContentId) {
        toast.error("Please upload a file first");
        return;
      }

      submitContent(finalMediaId, selectedContentId);
    };

    const submitContent = (mediaId, contentId) => {
      setIsUploading(true);

      const params = {
        assignment_id: assignmentDeepData.assignment_data.assignment_id,
        influencer_id: assignmentDeepData.assignment_data.influencer_id,
        content_id: contentId,
        content_media_id : mediaId
      };


        Core.submitContent(
          (response) => {
            handleUploadSuccess(contentId);
          },
          (error) => {
            handleUploadError(error.message || "Failed to submit content");
          },
          () => {},
          params
        );
      
    };

    const handleUploadSuccess = (contentId) => {
      setIsUploading(false);
      assignmentAdminDetails(updateProgress);
      setUploadedFile(null);
      setFilePreview(null);
      setSelectedContentId(null);
      setUploadType("file");
      
      // Mark this content as submitted
      setSubmittedContents(prev => ({
        ...prev,
        [contentId]: 'submitted'
      }));
      
      toast.success("Content submitted successfully!");

      // Reset the file input
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = "";
      }
    };

    const handleUploadError = (message) => {
      setIsUploading(false);
      setUploadedFile(null);
      setFilePreview(null);
      
      // Clear the pending status on error
      if (selectedContentId) {
        setSubmittedContents(prev => ({
          ...prev,
          [selectedContentId]: 'error'
        }));
      }
      setSelectedContentId(null);
      toast.error(message || "An error occurred during upload");
    }

    if (!assignmentDeepData.contents_deep_data) {
      return <div>No content to upload</div>;
    }

    return (
      <div className="content-pending-container">
        {Object.entries(assignmentDeepData.contents_deep_data).map(
          ([key, item]) => {
            const { content_data, platform_data } = item;
            const { content_type_id, status, content_id } = content_data;
            const isCurrentContent = selectedContentId == content_id;

            const contentTypeName =
              Utils.getContentTypeNameById(content_type_id) ||
              `Content Type ${content_type_id}`;

            const platformName = platform_data?.name;

            // 1. Handle "IN_REVIEW" status inside the map
            if (status === "IN_REVIEW") {
              return (
                <div
                  key={key}
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    backgroundColor: "#FFFBEB",
                    borderRadius: "8px",
                    borderLeft: "4px solid #F59E0B",
                    margin: "16px 0",
                  }}
                >
                  <CustomText
                    p
                    text={`${platformName} - ${contentTypeName} (In Review)`}
                    fontSize="font_size_medium"
                    textColor="#92400E"
                    style={{ fontWeight: 600, marginBottom: "8px" }}
                  />
                  <CustomText
                    p
                    text="Your content is currently under review. Please wait for approval."
                    fontSize="font_size_small"
                    textColor="#92400E"
                  />
                </div>
              );
            }
            if (status == "CONTENT_PENDING" || status == "COMPLETED") {
              return (
                <div
                  key={key}
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    backgroundColor: "#FFFBEB",
                    borderRadius: "8px",
                    borderLeft: "4px solid #F59E0B",
                    margin: "16px 0",
                  }}
                >
                  <CustomText
                    p
                    text={`${contentTypeName} has been approved`}
                    fontSize="font_size_small"
                    textColor="#92400E"
                  />
                </div>
              );
            }

            return (
              <div
                key={key}
                className="content-upload-option"
                style={{
                  marginBottom: "16px",
                  padding: "16px",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  backgroundColor: "#F9FAFB",
                }}
              >
                {/* Platform Header */}
                {platformName && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "12px",
                      color: "#4B5563",
                      fontSize: "14px",
                    }}
                  >
                    <Icon
                      iconName={Utils.socialMediaIcons(
                        platform_data?.platform_id
                      )}
                      width={20}
                      height={20}
                      style={{ marginRight: "8px" }}
                    />
                    <span>{platformName}</span>
                  </div>
                )}

                {/* Upload Box */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "20px",
                    border:
                      isCurrentContent && filePreview
                        ? "2px solid #4F46E5"
                        : "2px dashed #E5E7EB",
                    borderRadius: "8px",
                    backgroundColor: "white",
                    transition: "border-color 0.2s ease-in-out",
                  }}
                >
                  {!isCurrentContent || !filePreview ? (
                    <>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        {/* Toggle between file and link upload */}
                        

                        {uploadType === "file" ? (
                          <div
                            style={{ marginBottom: "12px", cursor: "pointer" }}
                            onClick={() => handleUploadClick(content_id)}
                          >
                            <UploadContentIcon fill="#6B7280" />
                            <CustomText
                              p
                              className="Body-1 m-t-8"
                              text={`Upload ${contentTypeName}`}
                              textColor="text_color_gray_500"
                            />
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "12px",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{ position: "relative", width: "100%" }}
                            >
                              <input
                                type="url"
                                value={getContentUrl(content_id)}
                                onChange={(e) => handleContentUrlChange(content_id, e.target.value)}
                                placeholder="Paste your content URL here"
                                style={{
                                  padding: "10px 40px 10px 12px",
                                  borderRadius: "6px",
                                  border: "1px solid #D1D5DB",
                                  fontSize: "14px",
                                  width: "100%",
                                  boxSizing: "border-box",
                                  transition: "border-color 0.2s ease-in-out",
                                  ":focus": {
                                    outline: "none",
                                    borderColor: "#4F46E5",
                                    boxShadow:
                                      "0 0 0 2px rgba(79, 70, 229, 0.2)",
                                  },
                                }}
                              />
                              {getContentUrl(content_id) && (
                                <button
                                  type="button"
                                  onClick={() => handleContentUrlChange(content_id, "")}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "#6B7280",
                                    padding: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M18 6L6 18M6 6L18 18"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </button>
                              )}
                            </div>
                            <button
                              onClick={() => {
                                const url = getContentUrl(content_id);
                                if (!url) {
                                  toast.error("Please enter a URL");
                                  return;
                                }

                                // Basic URL validation
                                try {
                                  new URL(url);
                                  submitContent(url, content_id, true);
                                } catch (e) {
                                  toast.error(
                                    "Please enter a valid URL (e.g., https://example.com)"
                                  );
                                }
                              }}
                              disabled={isUploading}
                              style={{
                                padding: "10px 16px",
                                background: "#4F46E5",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: 500,
                                opacity: isUploading ? 0.7 : 1,
                                pointerEvents: isUploading ? "none" : "auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                              }}
                            >
                              {isUploading ? (
                                <>
                                  <div
                                    className="spinner"
                                    style={{
                                      width: "16px",
                                      height: "16px",
                                      border: "2px solid rgba(255,255,255,0.3)",
                                      borderRadius: "50%",
                                      borderTopColor: "white",
                                      animation: "spin 1s ease-in-out infinite",
                                    }}
                                  />
                                  Submitting...
                                </>
                              ) : (
                                "Submit Link"
                              )}
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <div style={{ width: "100%" }}>
                      <div
                        style={{ textAlign: "center", marginBottom: "16px" }}
                      >
                        <h4>Preview</h4>
                        {uploadedFile?.type?.startsWith("image/") ? (
                          <img
                            src={filePreview}
                            alt="Uploaded content"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "300px",
                              borderRadius: "8px",
                              border: "1px solid #E5E7EB",
                            }}
                          />
                        ) : (
                          <video
                            controls
                            style={{
                              maxWidth: "100%",
                              maxHeight: "300px",
                              borderRadius: "8px",
                            }}
                          >
                            <source
                              src={filePreview}
                              type={uploadedFile?.type}
                            />
                            Your browser does not support the video tag.
                          </video>
                        )}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          marginTop: "16px",
                        }}
                      >
                        <button
                          onClick={() => {
                            if (uploadType === "file") {
                              handleUploadClick(selectedContentId);
                              
                            } else {
                              setUploadType("file");
                              setFilePreview(null);
                              setUploadedFile(null);
                              // Trigger file picker after a small delay to ensure state is updated
                              setTimeout(() => {
                                handleUploadClick(selectedContentId);
                              }, 100);
                            }
                          }}
                          style={{
                            flex: 1,
                            padding: "8px",
                            borderRadius: "6px",
                            border: "1px solid #D1D5DB",
                            cursor: "pointer",
                          }}
                        >
                          Change {uploadType === "file" ? "File" : "Link"}
                        </button>
                        <button
                          onClick={() => {
                            if (uploadType === "file") {
                              handleSubmitContent();
                            } else {
                              const url = getContentUrl(selectedContentId);
                              if (url) {
                                submitContent(
                                  url,
                                  selectedContentId,
                                  true
                                );
                              } else {
                                toast.error("Please enter a valid URL");
                              }
                            }
                          }}
                          disabled={isUploading}
                          style={{
                            flex: 1,
                            padding: "8px",
                            backgroundColor: "#4F46E5",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            opacity: isUploading ? 0.7 : 1,
                            pointerEvents: isUploading ? "none" : "auto",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                          }}
                        >
                          {isUploading ? (
                            <>
                              <div
                                className="spinner"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  border: "2px solid rgba(255,255,255,0.3)",
                                  borderRadius: "50%",
                                  borderTopColor: "white",
                                  animation: "spin 1s ease-in-out infinite",
                                }}
                              />
                              Submitting...
                            </>
                          ) : (
                            "Submit Content"
                          )}
                        </button>
                      </div>
                    </div>
                  )}

                  <CustomText
                    p
                    className="Caption1 m-t-12"
                    text={`Status: ${status}`}
                    textColor={
                      status === "REWORK"
                        ? "text_general_color_error"
                        : "text_color_gray_400"
                    }
                  />
                </div>
              </div>
            );
          }
        )}

        {/* Styles for any potential animations */}
        <style>
          {`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        .spinner {
          display: inline-block;
          animation: spin 1s linear infinite;
        }
      `}
        </style>
      </div>
    );
  }

  function currentTime() {
    // Get the current date
    const currentDate = new Date();

    // Set the time to 3:00 PM
    const timeAdjustedDate = setMinutes(setHours(currentDate, 15), 0);

    // Format the date
    const formattedDate = format(timeAdjustedDate, "eeee, h:mm a");
    return formattedDate;
  }

  // vertical steps
  const steps = [
    {
      label: "Content Submission",
      description: ContentPending(),
    },
    {
      label: "In-Review",
      description: ContentInReview(),
    },
    {
      label: "Completed",
      description: ContentCompleted(),
    },
  ];

  return (
    <>
      <>
        <div className="m-b-12">
          <CustomText
            p
            text={"Content Status"}
            textColor={"text_color_gray_500"}
            fontSize={"font_size_h7"}
            textAlign={"text_align_left"}
            fontWeight={"Inter_Bold"}
            lineHeight={"line_height_24"}
          />
        </div>
        {Object.keys(assignmentDeepData).length !== 0 && (
          <>
            <div className="content-container-main">
              <div className="content-status-container-box">
                <Stepper activeStep={activeStep} orientation="vertical">
                  {steps.map((step, index) => (
                    <Step key={step.label} expanded={true}>
                      <StepLabel className="Caption-3">{step.label}</StepLabel>
                      <StepContent>{step.description}</StepContent>
                    </Step>
                  ))}
                </Stepper>
              </div>

              {/* {assignmentDeepData.assignment_data.assignment_status ==
                "COMPLETED" && (
                <div className="rating-star">
                  <CustomText
                    p
                    text={"Rate your Collaboration Experience with"}
                    textColor={"text_color_primary"}
                    fontSize={"font_size_l"}
                    className="rating-para"
                  />
                  <CustomText
                    p
                    text={assignmentDeepData.influencer_data.name}
                    textColor={"text_color_primary"}
                    fontSize={"font_size_2xl"}
                    className="name-rating"
                  />
                  <div className="rating-icon">
                    <Rating
                      size={42}
                      initialValue={
                        assignmentDeepData.rating_data[0]?.review_points ||
                        rating
                      }
                      onClick={handleRating}
                      readonly={
                        assignmentDeepData?.rating_data.length == 0
                          ? false
                          : true
                      }
                    />
                  </div>
                  {assignmentDeepData.rating_data.length == 0 && (
                    <PrimaryCta
                      third
                      fullWidth={true}
                      fontSize={"font_size_large"}
                      text={"Submit"}
                      isLoading={isRatingButtonLoading}
                      className={
                        rating == 0 ? "submit-rating" : "submit-rating-after"
                      }
                      // onClick={()=>postRatingInfluencer() }
                      onClick={() => {
                        postRatingInfluencer();
                      }}
                    />
                  )}
                </div>
              )} */}
              {assignmentDeepData.assignment_data.assignment_status !==
                "COMPLETED" &&
                assignmentDeepData.assignment_data.assignment_status !==
                  "CANCELLED" && (
                  <div className="button-box">
                    <PrimaryCta
                      invert
                      fontSize={"font_size_large"}
                      text={"Cancel Contract"}
                      onClick={() => {
                        toggleModal();
                      }}
                    />
                  </div>
                )}
            </div>
          </>
        )}
      </>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
      >
        <div onClick={closeModal} className="close-btn-icon m-b-15">
          <Icon iconName="CloseRoundButtonIcon" />
        </div>
        <div className="m-t-36">
          <CustomText
            p
            textColor={"text_color_primary"}
            fontSize={"font_size_medium"}
            text={"Content review*"}
            textAlign={"text_align_left"}
          />
          <div className="brand-text-area m-t-12">
            <CustomTextArea
              className="background-white"
              placeholder={"Please enter your content review"}
              value={rejectedText}
              onChange={(e) => setRejectedText(e.target.value)}
              onBlur={(e) => validateContent(e.target.value)}
            />
          </div>
        </div>
        <h5 className="error">{error.content_rejected}</h5>
        <div className="m-t-12">
          <PrimaryCta
            fifth
            fullWidth={true}
            onClick={() => {
              ContentStatusRejected(selectedContentId);
              closeModal();
            }}
            fontSize={"font_size_large"}
            text={"Submit Review"}
          />
        </div>
      </Modal>

      {/* open on close contract */}
      {
        <ModalComponent
          isOpen={openModal2}
          onRequestClose={() => toggleCloseModal()}
          customStyle={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 999999,
            },
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              // borderColor: "#f55879",
              backgroundColor: "#F0F3F9",

              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
            },
          }}
        >
          <div className="">
            <CustomText
              h3
              text={"Are you sure to Cancel Contract?"}
              textColor={"#040408"}
              className="m-b-8 "
            />
          </div>
          <div
            style={{
              marginTop: "20px",
              display: "flex ",
              justifyContent: "center",
              gap: "30px",
            }}
          >
            <PrimaryCta
              invert
              className="back-btn-campaign"
              onClick={() => toggleCloseModal()}
              fontSize={"font_size_large"}
              text={"No"}
            />
            <PrimaryCta
              third
              fontSize={"font_size_regular"}
              className="header-credit-right"
              text={"Yes"}
              isLoading={cancelContractLoading}
              onClick={() => postCancelContract()}
            />
          </div>
        </ModalComponent>
      }

      <Modal
        isOpen={showmodal}
        onRequestClose={HideModel}
        style={CancelReminder}
      >
        <div onClick={() => HideModel()} className="close-btn-icon m-b-15">
          <Icon iconName="CloseRoundButtonIcon" />
        </div>
        <div className="contract-cancellation-confirm">
          <div style={{ textAlign: "left" }}>
            {/* <h2 className="cancel-text">Contract Terms</h2> */}
            <p className="cancel-request ">
              <h3 className="cancel-text">Contract Terms</h3>
              <ul className="contract-term-heading">
                <li>
                  Contract can be cancelled only if creator denies uploading
                  content
                </li>
                <li>
                  Contract can be cancelled if creator doesn’t followed the
                  instruction and violated any guidelines.
                </li>
                <li>
                  Contract can not be cancelled over performance or quality
                  issue.
                </li>
              </ul>
            </p>
          </div>

          {/* <div className="btn-accept-reject">
            <div className="confirm-cancelliation">
              {isLoading ? (
                <Loader />
              ) : (
                <>
                  <button
                    className="confirm-btn"
                    onClick={() => postAssignmentWithdraw()}
                  >
                    Cancel contract
                  </button>

                  <button className="keep-contract" onClick={() => HideModel()}>
                    Keep contract
                  </button>
                </>
              )}
            </div>
          </div> */}
        </div>
      </Modal>
      {payoutOpen && (
        <PayoutFlyOut
          contentsDeepData={assignmentDeepData}
          payoutOpen={payoutOpen}
          toggleFlyoutDropdown={toggleFlyoutDropdown}
          pgOrderId={pgOrderId}
          isLoadingButton={Object.values(loadingButtons).some(Boolean)}
        />
      )}

      {approveDialog && (
        <ConfirmationDialog
          title={"Approve"}
          subtext={"Are you sure, you want to Approve this content?"}
          open={approveDialog}
          handleClose={handleCancel}
          handelAgree={() => ""}
        />
      )}
      <ToastContainer />
    </>
  );
}

export default ContentAdminStatusScreen;
